import React from 'react';
import { connect, useDispatch   } from "react-redux";
import './Products.scss';
import Product from './Product';  
import { setCurrentProduct } from '../../redux/Order/order.actions';
import { dealOfTheMonthArr } from '../../helpers/productSorters';
import DealOfTheMonth from './DealOfTheMonth';

const mapStateToProps = (state) => ({
  productsObj: state.product.balls,
})


function Products(props) {

  const { events,products } = props;

  const dispatch = useDispatch();

  const changeSelectedProduct = (_productObj) => {
    dispatch(setCurrentProduct(_productObj));
  }

	const currentDate = new Date();
	const currentDateISO = currentDate.toISOString();

  /* 

  NOTES:
  	props.products contains all of the products that should be shown here (filters applied),
  	in the order of what ever sort is set.
  	productsObj contains all products

  TO DO HERE
  1. Create non_dotm_products array
  2. Loop through props.products
  3. Pull out any DOTM (where current date is between props.products.this.DealOfMonthStart and props.products.this.DealOfMonthEnd)
  4. Add any matches to DOTM products array
  5. Add any non-matches to non_dotm_products array
  */

/*  function reOrderArrForHotDeals(inArr) {

      const reorderedArr = [];

      inArr.map((thisObj,x) => {

      	if (thisObj.Discount > 0) {
      		reorderedArr.unshift(thisObj)
      	} else {
      		reorderedArr.push(thisObj)
      	}

      });

      return reorderedArr;

    }






  function findDotm(inArr) {

      const newArr = [];

      inArr.map((thisObj,x) => {

				// Create two Date objects
				const startDate = new Date(thisObj.DealOfMonthStart);
				const endDate = new Date(thisObj.DealofMonthStop);
				// Convert the dates to ISO strings
				const startDateISO = startDate.toISOString();
				const endDateISO = endDate.toISOString();


      	if ((currentDateISO > startDateISO) && (currentDateISO < endDateISO) && (thisObj.Live === true)) {
      		newArr.push({...thisObj})
      	}

      });

      return newArr;

    }

*/


  //const organizedProdArr = removeDOTM(props.products);
  const dotmArr = [...dealOfTheMonthArr(props.productsObj)];


  return (
  	<>
  		<DealOfTheMonth changeSelectedProduct={changeSelectedProduct} events={events} windowType={'standard'} />
	    <div className="row py-4 my-2">
	        {
	          props.products.map((productObj,x) => {

	          	if (!productObj.dotm) {
		            return productObj.Live === true ? <div className="col-6 col-lg-4"><Product changeSelectedProduct={changeSelectedProduct} events={events} product={productObj} key={productObj.ID} /></div> : null
	          	} else {
								console.log("DOTM DETECTED", x, productObj)
	          	}
	          })
	        }
	    </div>
    </>
  )
}

export default connect(mapStateToProps)(Products)